import React, { useState } from 'react';
import styles from '../styles/FAQ.module.css';

const faqData = [
    {
        question: "対応ツールは？",
        answer: "Autodesk Mayaをメインツールとしています。"
    },
    {
        question: "ゲーム案件に常駐することは可能か？",
        answer: "プロジェクト初期のみネットワーク構築を目的として現地入りすることは可能ですが、基本的には在宅勤務とさせていただきます。"
    },
    {
        question: "デモリールなどを見ることはできるか？",
        answer: "技術紹介ページをご覧ください（別リンクへ）"
    },
    {
        question: "仕様決めなどの初期フェーズから入ってもらうことは可能か？",
        answer: "仕様策定も可能です。弊社技術紹介ページを参考としてご覧ください。ゲームエンジン毎・DCCツール別の対応範囲についてはお問い合わせください。"
    },
    {
        question: "スクリプト対応はできるか？",
        answer: "社内仕様としてpythonを使用しているため基本的な操作は可能ですが、メンバーによって習熟度には差があります。詳細については個別にお問い合わせください。"
    },
    {
        question: "カバーしているリグツールは？",
        answer: "Mayaのmgearを強みとしていますがクライアントの独自リグでの業務も可能です。"
    },
    {
        question: "リモートにおけるセキュリティ対応は？",
        answer: "会社PCを支給し、業務データは全てGoogleドライブ上で管理しています。セキュリティソフトを全員導入してデータの安全性を高めています。プロジェクトによってはクライアントの環境にリモートアクセスして業務にあたることもございます。"
    }
];

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>FAQ</h2>
            <div className={styles.faqList}>
                {faqData.map((item, index) => (
                    <div
                        key={index}
                        className={`${styles.faqItem} ${openIndex === index ? styles.open : ''}`}
                    >
                        {/* コーナー装飾 */}
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>

                        <div
                            className={styles.questionArea}
                            onClick={() => toggleAccordion(index)}
                        >
                            <span className={styles.qIcon}>Q.</span>
                            <h3 className={styles.questionText}>{item.question}</h3>
                            <span className={styles.toggleIcon}>
                                {openIndex === index ? '−' : '＋'}
                            </span>
                        </div>

                        <div className={styles.answerArea}>
                            <div className={styles.answerAreaInner}>
                                <div className={styles.answerContent}>
                                    <span className={styles.aIcon}>A.</span>
                                    <p className={styles.answerText}>{item.answer}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;
